import React from 'react';
import classnames from "classnames";
import PropTypes from "prop-types";

function PaymentRadio ({ isSelected, className }) {

    const iconClassNames = classnames(`${className} otrl`, {
        'otrl-select': !isSelected,
        'otrl-selected': isSelected,
    });

    return (
        <span className={ iconClassNames } />
    );
}

PaymentRadio.propTypes = {
    isSelected: PropTypes.bool,
    className: PropTypes.string,
};


export default PaymentRadio;
